import React from "react";

import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalCloseButton,
  ModalBody,
  ModalFooter,
  Box,
  Spinner
} from "@chakra-ui/react";

import api from "services/api";
import "./style.scss";
import { useCustomToast } from "hooks/useToast";
import { useAuth } from "hooks/useAuth";
import { _t } from "content";
import { CiReceipt } from "react-icons/ci";
import { CiCircleInfo } from "react-icons/ci";
import { useNavigate } from "react-router-dom";

const IconeNotificacao = ({tipo, setModal}) => {
    const navigate = useNavigate();

    const handleClick = (url) => {
        setModal(false);
        navigate(url);
    }


    if (tipo === "cupom") {
        return <Box className="notificacao-icon" onClick={() => handleClick("/cupom")}>
            <CiReceipt size={30} color="#000" />
        </Box>;
    }
    else {
        return <Box className="notificacao-icon" onClick={() => handleClick("/home")}>
            <CiCircleInfo size={30} color="#000" />
        </Box>;
    }

}

const NotificacaoPage = ({modal, setModal}) => {

    const [rows, setRows] = React.useState<any>([]);
    const [qtdPaginas, setQtdPaginas] = React.useState<any>(0);
    const { getToast } = useCustomToast();
    const { user } = useAuth();
 
    const [pageState, setPageState] = React.useState<any>(
        {
            processando: false,
            page: 1,
            nrecpage: 50
        });

    React.useEffect(() => {
        const obterNotificacoes = async () => {
            if (pageState.processando === true)
                return;

            setPageState({...pageState, processando: true});
        try {
            const request = {
                pagina: pageState.page,
                qtdItens: pageState.nrecpage,
                objeto: {
                    cadastroId: user?.cadastroId,
                }
            }
            const { data } = await api.post("/notificacao/pesquisar", request);
            setPageState({...pageState, processando: false});
            if (!data) {
                getToast({
                    messageError: "Nenhum registro encontrado",
                    status: "warning",
                });
                return;
            }
            setQtdPaginas(data.qtdPaginas);
            sessionStorage.setItem("@farma.notify.new", '0');
            const lista = data.retorno.map((item:any) => {
                const detail = JSON.parse(item.mensagemJson);
                return {
                    titulo: item.titulo,
                    dataInclusao: item.dataInclusao,
                    icon: detail.icon,
                    mensagem: detail.mensagem,
                    info: detail.info,
                    tipo: detail.tipo
                }
            });
            setRows(lista);
            
            } catch (error) {
                setPageState({...pageState, processando: false});
                console.log(error);
                getToast({
                    messageError: "Erro ao obter notificações, tente novamente mais tarde",
                    status: "warning",
                });
            }
        }
        obterNotificacoes();
    }, []);

    if (modal === true) {

        return (
            <Modal
                isOpen={modal}
                onClose={() => setModal(false)}
                isCentered={true}
            >
            <ModalOverlay />
            <ModalContent maxWidth={'40%'}>
                <ModalHeader padding={7}>Notificações</ModalHeader>
                <ModalCloseButton _focus={{border: 'none'}} />
                <ModalBody pb={6} maxHeight={'400px'} overflowY={'auto'}>

                    {rows.map((row:any, index:number) => (
                    <Box key={index} className="notificacao-item">
                        <IconeNotificacao tipo={row.icon} setModal={setModal} />
                        <Box style={{flex: 1}}>
                            <Box style={{display: 'flex'}}>
                                <Box className="notificacao-titulo" style={{flex: 1}}>{row.titulo}</Box>
                                <Box className="notificacao-texto">{row.dataInclusao}</Box>
                            </Box>
                            <Box className="notificacao-texto">{row.mensagem}</Box>
                        </Box>
                        
                    </Box>
                    ))}

                </ModalBody>
            </ModalContent>
            </Modal>
        );

    }
    else {

        return (
            <>
            {rows.map((row:any, index:number) => (
            <Box key={index} className="notificacao-item">
                <IconeNotificacao tipo={row.icon} setModal={setModal} />
                <Box style={{flex: 1}}>
                    <Box style={{display: 'flex'}}>
                        <Box className="notificacao-titulo" style={{flex: 1}}>{row.titulo}</Box>
                        <Box className="notificacao-texto">{row.dataInclusao}</Box>
                    </Box>
                    <Box className="notificacao-texto">{row.mensagem}</Box>
                </Box>
                
            </Box>
            ))}
            </>
        );

    }

    

}

export default NotificacaoPage;

